<template>
	<div>
		<div v-if="!authenticated" class="alert alert-danger alert-dismissible fade show shadow-sm" :style="'width: -webkit-fill-available'" role="alert">
			An error occured during Login. <a href="/contact-us?subject=1" class="tx-bold" :style="'color: #721c24'">Contact Us</a>
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">×</span>
			</button>
		</div>

		<h3 class="tx-color-01">Login</h3>
		<p class="tx-color-03 mg-b-30">Please enter your credentials to continue.</p>
		<form method="POST" action="/login" @submit.prevent="login">
			<div class="form-group">
				<label>Email Address</label>
				<input v-model="form.email" type="email" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('email') }" name="email" placeholder="Enter your email address" required autocomplete="email" autofocus>
				<has-error :form="form" field="email"></has-error>
			</div>
			<div class="form-group">
				<label>Password</label>
				<input v-model="form.password" type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('password') }" name="password" placeholder="Enter your password" required autocomplete="current-password">
				<has-error :form="form" field="password"></has-error>
			</div>
			<button-component :busy="form.busy" :label="'Sign in'" :label-loading="'Please wait..'" :button-class="'btn btn-default btn-block'"></button-component>
		</form>

		<div class="tx-13 mg-t-40 tx-center">
			<a class="tx-inverse" :href="`/password/reset${resetEmail}`">Forgotten password?</a>
		</div>
	</div>
</template>

<script>
	import authentication from "../../mixins/authentication";

	export default {
		mixins: [authentication],
		mounted() {
			this.$store.dispatch("clearLocalStorage");
		},
		data: function() {
			return {
				resetEmail: "",
				authenticated: true,
				form: new Form({
					email: null,
					password: null
				})
			};
		},
		watch: {
			"form.email": function(value) {
				if (this.isValidEmail(value)) {
					this.resetEmail = `?${value}`;
				}
			}
		},
		methods: {
			login() {
				this.form.post("/login").then(({ data }) => {
					if (typeof data.user !== "undefined") {
						this.$store.dispatch("setLocalStorage", {
							user: JSON.stringify(data.user),
							token: data.token
						});

						window.location = data.intended;
					} else {
						this.authenticated = false;
					}
				});
			}
		}
	};
</script>
